import ComboBox from "../core/ComboBox";
import Badge from "../core/Badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faCheck } from "@fortawesome/free-solid-svg-icons";

const StatusDropdown = ({
  statuses = [],
  currentStatusId,
  statusLabel,
  statusColor,
  showDropdown,
  onToggle,
  onClose,
  onSelect,
  assignee,
  statusIdKey = "task_status_id",
}) => {
  const selectedStatus = statuses.find(
    (status) => status[statusIdKey] === currentStatusId
  );

  const selectedItems = selectedStatus ? [selectedStatus] : [];
  const displayLabel = statusLabel || selectedStatus?.name || "No Status";
  const displayColor = statusColor || selectedStatus?.color;

  return (
    <div className="inline-select">
      <button
        type="button"
        className="inline-select-trigger"
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
      >
        <Badge type="status" status={displayLabel} color={displayColor} />
        <FontAwesomeIcon
          icon={faChevronDown}
          className="inline-select-chevron"
        />
      </button>
      {showDropdown && assignee && (
        <div className="inline-select-dropdown">
          <ComboBox
            data={statuses}
            selected={selectedItems}
            valueKey={statusIdKey}
            placeholder="Search statuses..."
            searchTopic="status"
            formatData={(status) => (
              <div className="inline-option">
                <span
                  className="inline-option-color"
                  style={{
                    backgroundColor: status.color || "var(--border-color)",
                  }}
                />
                <span>{status.name}</span>
                {currentStatusId === status[statusIdKey] && (
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="inline-option-check"
                  />
                )}
              </div>
            )}
            handleSelect={(statusId) => {
              onSelect(statusId);
              onClose();
            }}
            onRequestClose={onClose}
            inline={true}
          />
        </div>
      )}
    </div>
  );
};

export default StatusDropdown;
